import * as React from 'react';
import { Device } from '../../../../../../common/Device';
import { PublicationFromPackageCheckboxDesktop } from './PublicationFromPackageCheckboxDesktop';
import { PublicationFromPackageCheckboxMobile } from './PublicationFromPackageCheckboxMobile';

interface IProps {
  label: string;
  checked: boolean;
  disabled: boolean;

  handleChange(): void;
}

export const PublicationFromPackageCheckbox = (props: IProps) => {
  return (
    <Device
      desktop={<PublicationFromPackageCheckboxDesktop {...props} />}
      mobile={<PublicationFromPackageCheckboxMobile {...props} />}
    />
  );
};
